import React from "react";
import logo from "../../images/EnvironmentalLabsLogoHorizontal.png";
import HtmlPdfTable from "./HtmlPdfTable";

const styles = {
  body: {
    padding: 25,
    backgroundColor: "white",
  },
  section: {
    margin: 2,
  },
};

const SinglePdfDocument = (data, showHeade,batchEditHistory) => {
  return (
    <div style={styles.body}>
      <img
        src={logo}
        alt="ELI Logo"
        style={{ maxHeight: "55px" }}
      />
      <p className="has-text-centered is-vcentered is-size-5 has-text-weight-bold">
        Reviewed Batch Samples
      </p>
      <div>        
        <br />
        <HtmlPdfTable data={ data } batchEditHistory={batchEditHistory} />
      </div>
    </div>
  );
};

const HtmlPdfDocument = React.forwardRef(
  ({ showHeader = true, data, pageOrientation, fileName,batchEditHistory }, ref) => {
    if (!data) return null;
    return (
      <div ref={ref}>
        <style type="text/css" media="print">
          {`\f
            @page { 
              size: ${pageOrientation}; 
              margin: 50px !important;
            }\
            html, body {
              height: initial !important;
              overflow: initial !important;
              -webkit-print-color-adjust: exact;
            }
          `}
        </style>
        <div style={{ backgroundColor: "white" }}>
          { SinglePdfDocument(data, showHeader,batchEditHistory) }
        </div>
      </div>
    );
  }
);

export default HtmlPdfDocument;
